var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHumberger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.6C0 1.16406 1.16406 0 2.6 0C4.03594 0 5.2 1.16406 5.2 2.6C5.2 4.03594 4.03594 5.2 2.6 5.2C1.16406 5.2 0 4.03594 0 2.6Z",
    fill: "#1C479B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4 2.6C10.4 1.16406 11.5641 0 13 0C14.4359 0 15.6 1.16406 15.6 2.6C15.6 4.03594 14.4359 5.2 13 5.2C11.5641 5.2 10.4 4.03594 10.4 2.6Z",
    fill: "#1C479B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8 2.6C20.8 1.16406 21.9641 0 23.4 0C24.8359 0 26 1.16406 26 2.6C26 4.03594 24.8359 5.2 23.4 5.2C21.9641 5.2 20.8 4.03594 20.8 2.6Z",
    fill: "#1C479B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 13C0 11.5641 1.16406 10.4 2.6 10.4C4.03594 10.4 5.2 11.5641 5.2 13C5.2 14.4359 4.03594 15.6 2.6 15.6C1.16406 15.6 0 14.4359 0 13Z",
    fill: "#1C479B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4 13C10.4 11.5641 11.5641 10.4 13 10.4C14.4359 10.4 15.6 11.5641 15.6 13C15.6 14.4359 14.4359 15.6 13 15.6C11.5641 15.6 10.4 14.4359 10.4 13Z",
    fill: "#1C479B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8 13C20.8 11.5641 21.9641 10.4 23.4 10.4C24.8359 10.4 26 11.5641 26 13C26 14.4359 24.8359 15.6 23.4 15.6C21.9641 15.6 20.8 14.4359 20.8 13Z",
    fill: "#1C479B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 23.4C0 21.9641 1.16406 20.8 2.6 20.8C4.03594 20.8 5.2 21.9641 5.2 23.4C5.2 24.8359 4.03594 26 2.6 26C1.16406 26 0 24.8359 0 23.4Z",
    fill: "#1C479B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4 23.4C10.4 21.9641 11.5641 20.8 13 20.8C14.4359 20.8 15.6 21.9641 15.6 23.4C15.6 24.8359 14.4359 26 13 26C11.5641 26 10.4 24.8359 10.4 23.4Z",
    fill: "#1C479B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8 23.4C20.8 21.9641 21.9641 20.8 23.4 20.8C24.8359 20.8 26 21.9641 26 23.4C26 24.8359 24.8359 26 23.4 26C21.9641 26 20.8 24.8359 20.8 23.4Z",
    fill: "#1C479B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumberger);
export default __webpack_public_path__ + "static/media/Humberger.033867b8aa9f07582ba327501bdf70d4.svg";
export { ForwardRef as ReactComponent };